import React from 'react';
import { Card } from '@/components/ui/card';
import { Checkbox } from '@/components/ui/checkbox';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { WA_STATUS } from './campaignUtils';

const fmt = (iso) => (iso ? new Date(iso).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' }) : '—');
const days = (iso) => (iso ? Math.max(0, Math.floor((Date.now() - new Date(iso)) / 86400000)) : null);

export function FollowupTable({ rows, showCampaign, canAct, selected, setSelected }) {
  const allSel = rows.length > 0 && rows.every((r) => selected.includes(r.id));
  const toggle = (id) => setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));

  return (
    <Card className="overflow-x-auto">
      <Table data-testid="followup-table">
        <TableHeader>
          <TableRow>
            {canAct && <TableHead className="w-8"><Checkbox checked={allSel} onCheckedChange={() => setSelected(allSel ? [] : rows.map((r) => r.id))} data-testid="followup-select-all" /></TableHead>}
            <TableHead>Pastor / Iglesia</TableHead>
            {showCampaign && <TableHead>Despliegue</TableHead>}
            <TableHead>WhatsApp</TableHead>
            <TableHead>Estado</TableHead>
            <TableHead>Último envío</TableHead>
            <TableHead>Reenvíos</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((r) => {
            const [label, cls] = WA_STATUS[r.wa_status] || WA_STATUS.none;
            const d = days(r.wa_sent_at);
            return (
              <TableRow key={r.id} data-testid={`followup-row-${r.id}`}>
                {canAct && <TableCell><Checkbox checked={selected.includes(r.id)} onCheckedChange={() => toggle(r.id)} data-testid={`followup-select-${r.id}`} /></TableCell>}
                <TableCell>
                  <div className="font-medium">{r.pastor || '—'}</div>
                  <div className="text-xs text-[hsl(var(--muted-foreground))]">{r.church || '—'}{r.city ? ` · ${r.city}` : ''}</div>
                </TableCell>
                {showCampaign && <TableCell className="text-sm">{r.campaign_name || '—'}</TableCell>}
                <TableCell className="text-sm">{r.phone}</TableCell>
                <TableCell>
                  <span className={`inline-flex px-2 py-0.5 rounded-full text-[11px] border ${cls}`} data-testid={`followup-status-${r.id}`}>
                    {r.group === 'read_no_reply' ? 'Leído, sin respuesta' : `${label}, sin abrir`}
                  </span>
                  {r.wa_read_at && <div className="text-[10px] text-[hsl(var(--muted-foreground))] mt-1">Leído {fmt(r.wa_read_at)}</div>}
                </TableCell>
                <TableCell className="text-sm">
                  {fmt(r.wa_sent_at)}
                  {d !== null && <div className="text-[10px] text-[hsl(var(--muted-foreground))]">hace {d} {d === 1 ? 'día' : 'días'}</div>}
                </TableCell>
                <TableCell className="text-sm" data-testid={`followup-resends-${r.id}`}>{r.wa_resends || 0}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
      {rows.length === 0 && (
        <div className="p-8 text-center text-sm text-[hsl(var(--muted-foreground))]" data-testid="followup-empty">
          No hay congregaciones en este grupo.
        </div>
      )}
    </Card>
  );
}
